import '../../scss/pages/blog.scss';
import 'swiper/dist/css/swiper.css';
import Swiper from 'swiper';
import {ProductListItem} from "../libraries/product-list/ProductListItem";

const bannerWrapper = document.querySelector('.blog-page-banner');

if (bannerWrapper) {
    new Swiper('.blog-page-banner.swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
            delay: 9000,
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    });
}

const swiperProducts = document.querySelector('.hobby-products-slider');

if (swiperProducts) {
    new Swiper('.hobby-products-slider.swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 46,
        scrollbar: {
            el: '.swiper-scrollbar',
            hide: true,
        },
        breakpoints: {
            768: {
                spaceBetween: 25
            },
        }
    });

    const sliderItems = swiperProducts.querySelectorAll('.swiper-slide');
    for (let item of sliderItems) {
        new ProductListItem(item);
    }
}

